<script setup lang="ts">
    import PkEditorRadioButtons from './PkEditorRadioButtons.vue'
    import { NotificationType, FrontendNotificationTypes } from 'models'
    import { computed } from 'vue'
    import { useI18n } from 'vue-i18n'

    const modelValue = defineModel<string | undefined>()

    defineProps<{
        name: string
        readonly?: boolean
    }>()

    const { t } = useI18n()
    const { t: $t } = useI18n({ useScope: 'global' })

    const options = computed(() =>
        FrontendNotificationTypes.map((value) => ({
            value,
            label: $t(`label.notificationType.${value}`),
        })),
    )
</script>

<template>
    <PkEditorRadioButtons v-model="modelValue" :name :options :readonly>
        <template #generic>
            <div>
                <div class="flex items-center gap-4 mb-4">
                    <VvIcon name="ri:notification-3-line" class="w-16 h-16" />
                    <strong class="font-semibold">
                        {{
                            $t(
                                `label.notificationType.${NotificationType.Generic}`,
                            )
                        }}
                    </strong>
                </div>
                <p class="text-word-3 text-12">
                    {{ t('genericInfo') }}
                </p>
            </div>
        </template>
        <template #organization>
            <div>
                <div class="flex items-center gap-4 mb-4">
                    <VvIcon name="ri:building-line" class="w-16 h-16" />
                    <strong class="font-semibold">
                        {{
                            $t(
                                `label.notificationType.${NotificationType.Organization}`,
                            )
                        }}
                    </strong>
                </div>
                <p class="text-word-3 text-12">
                    {{ t('organizationInfo') }}
                </p>
            </div>
        </template>
    </PkEditorRadioButtons>
</template>

<i18n lang="json">
{
    "en": {
        "genericInfo": "General-purpose notification. Can target all users, a specific organization, or a single user.",
        "organizationInfo": "Notification tied to organization events such as invites, membership changes, or access updates."
    },
    "it": {
        "genericInfo": "Notifica generica. Può essere indirizzata a tutti gli utenti, a un'organizzazione specifica o a un singolo utente.",
        "organizationInfo": "Notifica legata ad eventi di organizzazione come inviti, modifiche ai membri o aggiornamenti di accesso."
    }
}
</i18n>
